import * as React from "react"

const NoSearchResults = ({ classes }: { classes: string }) => {
  return (
    <div>
      <div className="ts-display-5 fw7 pv3 ph2">No Results found</div>
      <div className={`ph3 ph4-m br2 tl center pv3 bg-lwb-medium ${classes}`}>
        <div className="fw7">Some suggestions:</div>
        <div>Check all words are spelled correctly.</div>
        <div>Try different search terms.</div>
        <div>Try simpler terms.</div>
      </div>
    </div>
  )
}
export default NoSearchResults
